import { ResourceType } from "types";

export const RESOURCES_WITH_SEARCH_INDEX: ResourceType[] = [
  "assets",
  "anchors",
  "trackers",
  "devices",
  "instances"
];

export const hasFullTextSearchIndex = (resource: ResourceType) => {
  return RESOURCES_WITH_SEARCH_INDEX.includes(resource);
};
